export default class EmailCodeMismatch extends Error {
  name = 'EmailCodeMismatch';

  constructor(readonly message = 'Email CodeMismatch') {
    super(message);
  }
}
